import { apiPrefix, ConnectionService } from "./Connecion.service";

const RESOURCE = 'auth/DeviceModel';

class AuthDeviceModelService extends ConnectionService {

  constructor() {
    super();
    this.basedUrl = `${apiPrefix}/${RESOURCE}`;
  }

  async getDeviceModel(orgId, deviceUid) {
    const params = { organizationId: orgId, uid: deviceUid };
    return super.sendRequest(this.basedUrl, { params }, true);
  }

  async getAllDeviceModel() {
    const url = `${this.basedUrl}/allModel`;
    return super.sendRequest(url, {}, true);
  }

  async getDeviceModelFeatureList(model) {
    const url = `${this.basedUrl}/featureList`;
    const params = { name: model };
    return super.sendRequest(url, { params }, true);
  }

}

export default new AuthDeviceModelService();